import request from "@/utils/request";

// 列表
export function getList(data) {
  return request({
    url: "/api/examinee/get",
    method: "post",
    data,
  });
}
// 添加
export function addItem(data) {
  return request({
    url: "/api/examinee/add",
    method: "post",
    data,
  });
}
// 编辑
export function editItem(id, data) {
  return request({
    url: "/api/examinee/update",
    method: "post",
    data: { id, ...data },
  });
}
// 删除
export function delItem(data) {
  return request({
    url: "/api/examinee/delete",
    method: "post",
    data,
  });
}
// 成绩导入
export function uploadScore(data) {
  return request({
    url: "/api/examinee/uploadscore",
    method: "post",
    data,
  });
}
// 导出
export function exportItem() {
  return request({
    url: "/api/examinee/export",
  });
}
// 证书导入
export function uploadCert(data) {
  return request({
    url: "/api/examinee/uploadcert",
    method: "post",
    data,
  });
}